import {
  DEFAULT_HOTKEYS,
  HOTKEYS,
  EMPTY_HOTKEY_COMBINATION,
  EXCLUDE_HOTKEY,
  MENU_ITEMS
} from 'enums'
import { EDITOR_MAIN_SETTINGS } from './config/constants/mainView'

// Prepares a set of default hotkeys with empty values and excludes some
export const switchUsedHotkeys = ({
  switchOffKeys = [],
  excludedKeys = [],
}: {
  switchOffKeys: Array<HotkeysType>,
  excludedKeys?: Array<HotkeysType>
}) => (
    Object.keys(DEFAULT_HOTKEYS) as Array<HotkeysType>).reduce((result, key) => {
  // eslint-disable-next-line no-param-reassign
  result[key] = !switchOffKeys.includes(key)
    ? DEFAULT_HOTKEYS[key as typeof HOTKEYS[HotkeysType]]
    : EMPTY_HOTKEY_COMBINATION
  if (excludedKeys.includes(key)) {
    // eslint-disable-next-line no-param-reassign
    result[key] = EXCLUDE_HOTKEY
  }
  return result
}, {} as Record<HotkeysType, string>)

export const mergeHotkeys = ({
  customHotkeys,
  defaultHotkeys,
}: {
  customHotkeys: Record<HotkeysValueType, string>
  defaultHotkeys: Record<HotkeysValueType, string>
}) => Object.entries(defaultHotkeys).reduce((result, [ key, defaultCombination ]) => {
  if (!Object.hasOwn(customHotkeys, key)) {
    const hasConflict = Object
      .values(customHotkeys)
      .find(customCombination => customCombination === defaultCombination)
    // eslint-disable-next-line no-param-reassign
    result[key as HotkeysValueType] = hasConflict ? EMPTY_HOTKEY_COMBINATION : defaultCombination
  } else {
    // eslint-disable-next-line no-param-reassign
    result[key as HotkeysValueType] = customHotkeys[key as HotkeysValueType]
  }
  return result
}, { ...customHotkeys } as Record<HotkeysValueType, string>)


export const getEnabledMenuItems = () => [
  { menuItem: MENU_ITEMS.MEDIA, visible: __CFG__.SOURCE_FILES_TYPES.MEDIA },
  { menuItem: MENU_ITEMS.PROJECT_MEDIA, visible: __CFG__.SOURCE_FILES_TYPES.PROJECT_MEDIA },
  { menuItem: MENU_ITEMS.AUDIO, visible: __CFG__.SOURCE_FILES_TYPES.AUDIO },
  { menuItem: MENU_ITEMS.TEXT, visible: __CFG__.SOURCE_FILES_TYPES.TEXT },
  { menuItem: MENU_ITEMS.TRANSITIONS, visible: __CFG__.SOURCE_FILES_TYPES.TRANSITIONS },
  { menuItem: MENU_ITEMS.FILTERS, visible: __CFG__.SOURCE_FILES_TYPES.FILTERS },
  { menuItem: MENU_ITEMS.DESIGN, visible: __CFG__.SOURCE_FILES_TYPES.DESIGN },
  { menuItem: MENU_ITEMS.IMAGES, visible: __CFG__.SOURCE_FILES_TYPES.IMAGES },
]

export const setChapterAtStorage = (chapter: string) => {
  localStorage.setItem('currentChapter', chapter)
}

export const getDefaultChapterFromStorage = () => {
  const currentChapter = localStorage.getItem('currentChapter')
  const viewSettings = localStorage.getItem(EDITOR_MAIN_SETTINGS.VIEW)
  let enabledIcons = getEnabledMenuItems()
  if (viewSettings) {
    const { showProjectMedia, showMyMedia } = JSON.parse(viewSettings)
    enabledIcons = getEnabledMenuItems().filter(({ menuItem, visible }) => {
      if (menuItem === MENU_ITEMS.PROJECT_MEDIA) {
        return showProjectMedia != null ? !!showProjectMedia : visible
      }
      if (menuItem === MENU_ITEMS.MEDIA) {
        return showMyMedia != null ? !!showMyMedia : visible
      }
      return visible
    })
  } else {
    enabledIcons = getEnabledMenuItems().filter(({ visible }) => visible)
  }

  if (!currentChapter
    || !enabledIcons.find(({ menuItem }) => menuItem === currentChapter)) {
    const activeItem = enabledIcons[0]?.menuItem || ''
    setChapterAtStorage(activeItem)
    return activeItem
  }

  return currentChapter
}
